import { render } from "./New.vue?vue&type=template&id=26a5776b"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"

import "./New.vue?vue&type=style&index=0&id=26a5776b&lang=css"
script.render = render

export default script